export default __webpack_public_path__ + "static/riktig-lag-rekkefølge-eksempel1-58f90e1e787e0c48fc958b1628bb5960.png";